import React, { createContext, useState } from "react";
import { User } from "../models/User";

type UserContextType = {
  userDetails: User | null;
  addUserDetails: (user: User | null) => void;
  setJwtToken: (token: string | null) => void;
  isAuthenticated: boolean;
};

export const UserContext = createContext<UserContextType>(
  {} as UserContextType
);

export const validateUserInfo = (userHeader: string | null): User | null => {
  let parsedUserInfo = null;

  const keys = ["id", "type", "firstName", "lastName", "email"];

  if (userHeader) {
    try {
      const parsedUserHeader = JSON.parse(userHeader);
      if (keys.some((key) => parsedUserHeader[key] !== "string")) {
        parsedUserInfo = parsedUserHeader;
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  return parsedUserInfo;
};

type UserProviderProps = {
  children: React.ReactElement | React.ReactElement[];
};

export function UserProvider({ children }: UserProviderProps) {
  const [jwt, setJwt] = useState<string | null>(null);
  const [userDetails, setUserDetails] = useState<User | null>(null);

  function addUserDetails(user: User | null) {
    setUserDetails(user);
  }

  function setJwtToken(token: string | null) {
    setJwt(token);
  }

  return (
    <UserContext.Provider
      value={{
        isAuthenticated: userDetails !== null || jwt !== null,
        userDetails,
        addUserDetails,
        setJwtToken,
      }}
    >
      {children}
    </UserContext.Provider>
  );
}
